import { useEffect, type RefObject } from 'react';

/** Layout-only observation: quest text can wrap; it must never cover desktop map actions. */
export function useExploreQuestClearance(rootRef: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root || typeof ResizeObserver === 'undefined') return;
    const obstacles = [
      root.closest('.ar-scene-content')?.querySelector(':scope > .ar-shell-quest'),
      root.querySelector('.live-guide-coachmark'),
    ].filter((element): element is Element => Boolean(element));
    const measure = () => {
      const rootTop = root.getBoundingClientRect().top;
      const clearance = Math.max(
        16,
        ...obstacles.map((element) => element.getBoundingClientRect().bottom - rootTop + 12),
      );
      root.style.setProperty('--explore-quest-clearance', `${Math.ceil(clearance)}px`);
    };
    const observer = new ResizeObserver(measure);
    obstacles.forEach((element) => observer.observe(element));
    window.addEventListener('resize', measure);
    measure();
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
      root.style.removeProperty('--explore-quest-clearance');
    };
  }, [rootRef]);
}
